'use strict';

module.exports = require('./Trigger');